/**
 * F-160 D1 — minimal notifications store for the bell badge.
 *
 * Keeps only what the header needs: `unread_count` and a setter. Periodic
 * refresh lives in the consumer that mounts the bell (`Header`), so the
 * store stays tiny and side-effect free.
 *
 * Future: WS `notification` event handlers should call `incrementUnread()`
 * when a new push arrives, and `markAllRead()` should mirror the REST
 * `/notifications/read-all/` call.
 */
import { create } from 'zustand';

interface NotificationsState {
  unread_count: number;
  setUnread: (n: number) => void;
  incrementUnread: () => void;
  markAllRead: () => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  unread_count: 0,
  setUnread: (n) => set({ unread_count: Math.max(0, n) }),
  incrementUnread: () => set((s) => ({ unread_count: s.unread_count + 1 })),
  markAllRead: () => set({ unread_count: 0 }),
}));
